export const setAccessToken = (token) => {
    sessionStorage.setItem("accessToken", token);
};

export const getAccessToken = () => {
    return sessionStorage.getItem("accessToken");
};

export const removeAccessToken = () => {
    sessionStorage.removeItem("accessToken");
};

export const setUserStorage = (user) => {
    sessionStorage.setItem("user", JSON.stringify(user));
};

export const getUserStorage = () => {
    return sessionStorage.getItem("user");
};

export const removeUserStorage = () => {
    sessionStorage.removeItem("user");
};